import MondayUniverseHomepageFirstFoldComponent from "./monday-universe-homepage-first-fold-component";
import MondayUniverseHomepageFirstFoldConfig from "./monday-universe-homepage-first-fold-config";
import MondayUniverseHomepageFirstFoldAdvancedConfig from "./monday-universe-homepage-first-fold-advanced-config";

export default {
  MondayUniverseHomepageFirstFoldComponent,
  MondayUniverseHomepageFirstFoldConfig,
  MondayUniverseHomepageFirstFoldAdvancedConfig
};
